import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import Select from "react-select";
import { NavLink } from "react-router-dom";
import ReactTable from "../../AppComponent/Table";
import {
  SetTheActiveEmployeeListACtions,
  setTheoptions,
  setThecountBasedRenders,
  ////--filters
  setRegionActions,
  setZoneActions,
  setGeoLoactionStateAction,
  getSideBarfilesActions,
} from "../../../Redux/Slice";
import ActiveEmployeeApprove from "./ActiveEmployeeApprove";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import useDebouncedEffect from 'use-debounced-effect';

const ActiveEmployeeList = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const state = useSelector((state) => state);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(20);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setsearch] = useState("");
  const stastatete = useSelector((state) => state);
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [EmployeePop, setEmployeePop] = useState(false);
  const [EmployeeIDs, setEmployeeIDs] = useState();
  const [data, setDatas] = useState({ zone: "", state: "", region: "" });
  const [TotalCount, setTotalCount] = useState();

  ///---filter for white collar--------
  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "",
      label: "ALL",
    },
    {
      value: "1",
      label: "UDS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);

  const [EMpROleSelected, setEmpRoleSele] = useState(EmpRoles[0]);
  const FileterState = {
    status: "",
  };
  const [selectDisplay, setDisplay] = useState([]);
  const [selectVal, SetSelectval] = useState(FileterState);
  const [FState, SetStates] = useState(false);

  const UserObjectData = useSelector((state) => state.users.UserData);

  ////--_FIlter--------------------------
  const [Filter, SetFilter] = useState(true);
  /// console.log(state.NumberCounts, "fsdf");
  const optionsDetails = [
    { value: state.NumberCounts.Option1, label: "All" },
    { value: state.NumberCounts.Option3, label: "Pending" },
    { value: state.NumberCounts.Option4, label: "Decline" },
    { value: state.NumberCounts.Option5, label: "Approved" },
  ];
  const [place, SetPlace] = useState("");
  const [sel, setSelected] = useState();
  ///--filter----------------
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState([]);
  const [multiselect3, setMuliselect3] = useState([]);
  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [multiselect, setMuliselect] = useState([]);

  const [filterForWhite, setFilters] = useState({ white_collar: "" });
  const HandleEMprole = (e) => {
    setdtPageindex(1);

    if (e != null) {
      setEmpRoleSele(e);
      if (e.value == 1) {
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });
      } else if (e.value == 2) {
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
      }
      else if (e.value == "") {
        setFilters({
          ...filterForWhite,
          white_collar: "",
        });

      }
    }
  };
  //--------Place---Holder----dispatch======
  useEffect(() => {
    //  dispatch(setTheoptions({value:"", l}))
    if (state.NumberCounts.namerednder == "") {
      dispatch(setTheoptions(optionsDetails));
      SetPlace("All");
    }
    // if (state.NumberCounts.namerednder == "completed") {
    //   dispatch(setTheoptions(optionsDetails[0]));
    //   SetPlace("Completed");
    // }
    // if (state.NumberCounts.namerednder == "Decline") {
    //   dispatch(setTheoptions(optionsDetails[3]));
    //   SetPlace("Decline");
    // }
    // if (state.NumberCounts.namerednder == "Pending") {
    //   dispatch(setTheoptions(optionsDetails[2]));
    //   SetPlace("Pending");
    // }
  }, [state.NumberCounts.namerednder]);

  useEffect(() => {
    const payload = {
      search: "",
      page_size: 10,
      page: dtpageindex,
      selectVal: selectVal,
      data: data,
      white_collar: filterForWhite.white_collar,
    };
    dispatch(SetTheActiveEmployeeListACtions(payload));
  }, [selectVal, data, filterForWhite, dtpageindex]);

  console.log(state.ActveEmployeeList, "sadahsidwaios;");

  useEffect(() => {
    if (state.ActveEmployeeList.Total_Count != undefined) {
      setTotalCount(state.ActveEmployeeList.Total_Count);
    }
  }, [state.ActveEmployeeList.Total_Count]);

  ///----filter-----
  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);


  useEffect(() => {
    if (state.users.UserData.data != undefined) {
    }
    if (UserObjectData.session) {
      console.log(UserObjectData.data.state_id.length > 0, "session");
      const udsroleSelectedstate = [];

      if (UserObjectData.data.state_id.length > 0) {
        // setMuliselect()
        UserObjectData.data.state_id.map((item, index) => {
          if (index == 0) {
            udsroleSelectedstate.push({
              value: item.id,
              label: item.state_name,
            });
          }
        });

        setDatas({
          ...data,
          state: udsroleSelectedstate[0].value,
        });
      } else {
        udsroleSelectedstate.push({ value: "", label: "ALL" });
      }
      setMuliselect(udsroleSelectedstate);
    }
  }, [UserObjectData]);




  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: currentPage,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);
  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: currentPage,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);
  useEffect(() => {
    const Datas = [];
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name });
      });
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];
    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({ value: element.id, label: element.region_name.toUpperCase() });
      });
      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setDatas({
        ...data,
        region: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      setDatas({
        ...data,
        region: "",
        zone: "",
      });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setDatas({
        ...data,
        zone: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setMuliselect3({ value: "", label: "ALL" });

      setDatas({
        ...data,
        zone: "",
      });
    }
  };
  const handleSelectChange = (selectedVal) => {
    console.log(selectedVal, "selectedval");
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      console.log(selectedVal, "asfad");
      setDatas({
        ...data,
        state: selectedVal.value,
        region: "",
        zone: "",
      });
    }
    if (selectedVal == null) {
      setMuliselect1({ value: "search", label: "search" });
      setMuliselect3({ value: "search", label: "search" });
      setDatas({
        ...data,
        state: "",
        zone: "",
        region: "",
      });
    }
  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];
    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({ value: element.id, label: element.zone_name.toUpperCase() });
      });
      setOptions4(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);


  useDebouncedEffect(
    () => {
        if (setSearchDebounance) {
            setSearched({
                ...SearchedVal,
                stateSearch: SearchDebounance.stateSearch,
                regionSearch: SearchDebounance.regionSearch,
                zoneSearch: SearchDebounance.zoneSearch,
            });

        }
    },
    500,
    [SearchDebounance]
);


  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        stateSearch: Val,

    });

};

///---Region-----------------
const handleInputRegion = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        regionSearch: Val,
    });
};
///----Zone---Name
const handleInputZone = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        zoneSearch: Val,
    });
};


  ///---Handle---Changes------
  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);

    setsearch(e);
    if (e.trim() != undefined && e.trim() != "") {
      const payload = {
        search: e.trim(),
        page_size: 20,
        page: 1,
        selectVal: selectVal,
        data: data,
        white_collar: filterForWhite.white_collar,
      };
      // console.log(e, "testnew")
      dispatch(SetTheActiveEmployeeListACtions(payload));
    }
    if (e == "" || search == "") {
      const payload = {
        search: "",
        page_size: 20,
        page: 1,
        selectVal: selectVal,
        data: data,
        white_collar: filterForWhite.white_collar,
      };
      dispatch(SetTheActiveEmployeeListACtions(payload));
    }
  }
  const handlePageChange = (newPage) => {
    if (newPage < state.ActveEmployeeList.Total_count) {
      setCurrentPage(newpages + 1);

      setNewpage(newPage + 1);
      const pageEntries = {
        search: search,
        page_size: 10,
        page: newPage,
        selectVal: selectVal,
        data: data,
        white_collar: filterForWhite.white_collar,
      };
      dispatch(SetTheActiveEmployeeListACtions(pageEntries));
    }
  };

  const handleNext = (next) => {
    setdtPageindex(next + 1);

  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage)
  }

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);

    }
  };



  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };


  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const ClearState = (Counts) => {
    if (Counts == 2) {
      SetSelectval({
        ...selectVal,
        status: "",
      });
      setdtPageindex(1);
    }
  };
  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    setDisplay(SelectedValues);
    setSelected(sel);
    SetStates(true);
    dispatch(setTheoptions(SelectedValues));
    dispatch(setThecountBasedRenders(2));
    setdtPageindex(1);

    if (values == "Pending") {
      ///Pending
      SetSelectval({
        ...selectVal,
        status: "pending",
      });
    } else if (values == "Decline") {
      //Decline
      SetSelectval({
        ...selectVal,
        status: "decline",
      });
    } else if (values == "Approved") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "approved",
      });
    } else if (values == "ALL") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "",
      });
    }
  };

  const column = [
    {
      Header: "Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <span>{row.row.original.user_id.first_name}</span>
          </>
        );
      },
    },
    {
      Header: "Created Date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
        return (
          <>
            <p
            >
              {`${row.row.original.created_at.slice(0, 10) + "  " + formattedTime
                }`}
            </p>
          </>
        );
      },
    },
    {
      Header: "Email",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.email ? (
              <span>{row.row.original.user_id.email}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Notes",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.notes != null ? (
              <span>{row.row.original.notes}</span>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Client",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.client_id != null &&
              row.row.original.client_id != undefined &&
              row.row.original.client_id.client_name != undefined ? (
              <span>{row.row.original.client_id.client_name}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Status",
      accessor: "status",
      Cell: (row) => {
        const originalString = row.row.original.status;
        const capitalizedString = capitalizeFirstLetter(originalString);
        return (
          <>
            {row.row.original.status != undefined ? (
              <>
                {row.row.original.status.toLowerCase() == "pending" ? (
                  <div className="StatusList">
                    <img src={Pendingimg} />
                    <span>{capitalizedString}</span>
                  </div>
                ) : (
                  <>
                    {row.row.original.status.toLowerCase() == "decline" ? (
                      <div className="StatusList">
                        <div className="DeclineStatus">
                          <span>x</span>
                        </div>
                        <span>{capitalizedString}</span>
                      </div>
                    ) : (
                      <>
                        {row.row.original.status.toLowerCase() == "approved" ? (
                          <div className="StatusList">
                            <img src={correctIcons} />
                            <span>{capitalizedString}</span>
                          </div>
                        ) : null}
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Action",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
             

              <button
                className=" btn Status"
                component="span"
                onClick={(e) => {
                  setEmployeePop(true);
                  setEmployeeIDs(row.row.original.id);
                }}
              >
                <span className="OuterActionSpan">
                  <span className="EditImages">
                    <img src={EditImages} />
                  </span>
                  <span className="ActionsList"> Approve </span>
                </span>
              </button>
            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Active and Deactive </h3>
            {/* <ul class="breadcrumb">
              <li class="breadcrumb-item">Active and Deactive</li>
            </ul> */}
          </div>
        </div>

        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col">
            <label for="validationCustom01" class="form-label">
              State
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                setdtPageindex(1);
                handleSelectChange(e);
              }}
              // isClearable={true}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
              }}
              labelledBy="Select"
              value={multiselect}
            />
          </div>
          <div className="col">
            <label for="validationCustom01" class="form-label">
              Region
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                setdtPageindex(1);

                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={true}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              onInputChange={handleInputRegion}
              value={multiselect1}
            />
          </div>
          <div className="col">
            <label for="validationCustom01" class="form-label">
              Zone
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                setdtPageindex(1);
                handleZone(e);
              }}
              options={nameList4}
              isClearable={true}
              onremoved={(e) => {
                setMuliselect3(e);
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
              value={multiselect3}
            />
          </div>
        </div>
        <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
      

          <ReactTable
            data={state.ActveEmployeeList.ActivEmployeeListDatas}
            columns={column}
            totalItems={state.ActveEmployeeList.Total_count}
            currentPage={currentPage}
            // onPageChange={handlePageChange}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            // pagesize={pagesize}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            // dtpagesize={pageSize}
            // dtpageindex={dtpageindex}
            // pageindex={pageindex}

            // datacount={state.ActveEmployeeList.Total_count}

            datacount={TotalCount}
            // onPageChange={handlePageChange}
            // onFirstPage={handleFirstPage}
            // Oncreate={(e) => setRoleCreatePopup(true)}

            pagesize={pagesize}
            // onPrevious={handlePrevious}
            // onNextpage={handleNext}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            values={state.NumberCounts.Options}
            options={optionsDetails}
            Filter={true}
            count={count}
            ClearState={ClearState}
            placeHold={place}
            ApproveRequestFilter={true}

            ///--- emoloyee role based filters -
            EmployeeRoleTrue={true}
            EmployeeRoleOption={EmpRoles}
            EMpROleSelected={EMpROleSelected}
            HandleEMprole={HandleEMprole}
          />
        </div>
      </div>

      {EmployeePop && EmployeeIDs != undefined ? (
        <ActiveEmployeeApprove
          show={EmployeeIDs}
          setShow={setEmployeePop}
          currentPage={dtpageindex}
          EditId={EmployeeIDs}
          selectVal={selectVal}
          data={data}
          white_collar={filterForWhite.white_collar}
        />
      ) : null}
    </>
  );
};

export default ActiveEmployeeList;
